export const calanderInitContants = {
  weekStartsOn: 3,
  q1StartsOn: 3
};
